/*
 * @Author: wuhao
 * @Date: 2019-08-09 11:40:11
 * @LastEditors: wuhao
 * @LastEditTime: 2019-08-29 17:39:41
 * @Description: 错误码拦截
 */
import Vue from 'vue'

let _this = new Vue()

const whiteList = [900]
const errorIntercept = ({ code, message }) => {
  if (code !== 200) {
    if (!whiteList.includes(code)) {
      _this.$message.error(message)
    }
    return true
  } else {
    return false
  }
}

export default errorIntercept



// WEBPACK FOOTER //
// ./src/utils/errorMessage.js